import { createContext } from 'react';
export var TableContext = /*#__PURE__*/createContext({
  stackable: false,
  warningDisabled: false
});
export default TableContext;